import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';

// NeoAssist é um widget de ATENDIMENTO de terceiro (SDK cdn.atendimen.to).
// - Em PROD (VITE_ENABLE_NEOASSIST=true + pageid + domínio liberado): carrega o SDK
//   e o NeoAssist renderiza o FAB "Fale conosco" (abas Início/E-mail/Chat/WhatsApp).
// - No PROTÓTIPO (desligado): mostra um FAB fallback que abre a Central de Ajuda,
//   pois o SDK de terceiro não renderiza em localhost sem config/domínio liberado.

const ENABLE = import.meta.env.VITE_ENABLE_NEOASSIST === 'true';
const PAGE_ID = import.meta.env.VITE_NEOASSIST_PAGE_ID ?? '';
const CLIENT_DOMAIN = import.meta.env.VITE_NEOASSIST_CLIENT_DOMAIN ?? 'agnes.neoassist.com';

declare global {
  interface Window {
    NeoAssistTagLoaded?: boolean;
    NeoAssistTag?: { pageid?: string; clientdomain?: string; querystring?: boolean };
  }
}

function useNeoAssistSdk() {
  useEffect(() => {
    if (!ENABLE || window.NeoAssistTagLoaded) return;
    window.NeoAssistTagLoaded = true;
    window.NeoAssistTag = { pageid: PAGE_ID, clientdomain: CLIENT_DOMAIN, querystring: true };

    const sdk = document.createElement('script');
    sdk.id = 'neoassist-sdk';
    sdk.async = true;
    sdk.src = 'https://cdn.atendimen.to/n.js';
    sdk.onerror = () => {
      console.error('[NeoAssist] Falha ao carregar o SDK (verificar domínio liberado no painel).');
      window.NeoAssistTagLoaded = false;
    };
    document.body.appendChild(sdk);

    return () => {
      window.NeoAssistTagLoaded = false;
      window.NeoAssistTag = undefined;
      document.getElementById('neoassist-sdk')?.remove();
      document
        .querySelectorAll('[id*="NeoAssist"], [id*="neoassist"], [class*="neoassist"]')
        .forEach((el) => el.remove());
    };
  }, []);
}

export function NeoAssist() {
  useNeoAssistSdk();
  const navigate = useNavigate();

  // SDK real ligado → ele desenha o próprio FAB; não renderizamos nada.
  if (ENABLE) return null;

  // Protótipo: FAB fallback → Central de Ajuda.
  return (
    <button
      onClick={() => navigate('/central-de-ajuda')}
      title="Fale conosco"
      className="fixed bottom-6 right-6 z-[1200] flex h-14 w-14 items-center justify-center rounded-full bg-agnes-primary text-white shadow-agnes-modal transition-transform hover:scale-105"
    >
      <MessageCircle className="h-6 w-6" />
    </button>
  );
}
